import KeywordRecord from 'records/keyword';
import { createCollectionActions } from 'utils/actionsGenerator';

import {
    ADD_PINNED_PRODUCT,
    FETCH_NORMALIZED_PRODUCTS,
    FETCH_NORMALIZED_PRODUCTS_FAIL,
    FETCH_NORMALIZED_PRODUCTS_SUCCESS,
    REMOVE_PINNED_PRODUCT,
    REMOVE_TRACKED_PRODUCT,
    types,
} from './reducer';

export const addKeywordToProduct = (keyword) => ({
    keyword: KeywordRecord(keyword),
    type: 'ADD_KEYWORD_TO_PRODUCT',
});

export const addPinnedProduct = (id) => ({
    id,
    type: ADD_PINNED_PRODUCT,
});

export const removePinnedProduct = (id) => ({
    id,
    type: REMOVE_PINNED_PRODUCT,
});

export const removeTrackedProduct = (id) => ({
    id,
    type: REMOVE_TRACKED_PRODUCT,
});

export const { fetch, post, reset } = createCollectionActions({
    name: 'products',
    params: { embeds: 'categories,listings,media' },
    types,
    url: '/products',
});

// TODO: Add caching
export const fetchNormalizedProducts = ({ name, params }) => ({
    name,
    payload: {
        request: {
            params,
            url: '/products',
        },
    },
    types: [
        FETCH_NORMALIZED_PRODUCTS,
        FETCH_NORMALIZED_PRODUCTS_SUCCESS,
        FETCH_NORMALIZED_PRODUCTS_FAIL,
    ],
});



// WEBPACK FOOTER //
// ./src/redux/products/actions.js